export const CHANNEL_NAME = 'enclave';
